import React, { useState, useEffect, useRef } from 'react';
import {useHistory} from "react-router-dom"

const delay = millis => new Promise((resolve, reject) => {
    setTimeout(_ => resolve(), millis)
  });


const useOcr=(props)=>
{
    const {videoRef,ocrActive,scanningStep,setScanningStep, setMediaStream, actPaket,setKorrektur,usersDB, shopDB,  dienst}=props
    const detectorText= useRef()
    const [userDetected,setUserDetected]=useState([])
    const [count,setCount]=useState(0)
    const scanTriesMulti=useRef(0)
    const scanTriesZero=useRef(0)
    const detectorError=useRef(0)
    const stopWords= useRef()
    const history=useHistory()

  useEffect(()=>
  {


    if(ocrActive.current && scanningStep!=='ocr-request' && ! detectorText.current)
    {
          detectorText.current=new window.TextDetector()
    }
    else if(ocrActive.current && scanningStep!=='ocr-request' && scanningStep!=='ocr')
    {
        detectorText.current=null
        ocrActive.current=false

    }
       
  

    function stopTextScan()
    {
        detectorText.current=null
        ocrActive.current=false
        scanTriesZero.current=0
        scanTriesMulti.current=0
        setScanningStep('completed')

    }
    const scanText = async ()=>
    { 
      // Scan Barcode
    
      if(!stopWords.current)
      {
        const shop= await shopDB.get('MyShop')
        if(shop)
        {
          stopWords.current=['und','GmbH','AG',...JSON.parse(shop.StopWords)]
        }
        if(!Array.isArray(stopWords.current))
            stopWords.current=[]
      }
      try {
        const texts = await detectorText.current.detect(videoRef.current);
        detectorError.current=0
        const score1=[]
        const score2=[]
        const score3=[]
        if(texts.length>0)
        {
          //await delay(10)
          
          const words=texts.map(el=>el.rawValue.split(/\W/)).flat()
            .filter(el=>(el.match(/[A-Z][a-zA-ZÄÖÜÁÉÀÈäöüàèéá]{3,16}$/)))
            .filter(el=>!stopWords.current.includes(el))
            .map(word=>(word.toLocaleLowerCase('de-DE').replaceAll(/[\:\+\-\,\.]/gm,'')))
          // get all word kunden combis
          const wordKunden= await Promise.all(
              words.map(word=>(usersDB.where('fulltextName').equals(word).toArray()))
              )
           // perform scoring   
           wordKunden.map(kunden=>
            {
              kunden.map(kunde=>
              {
                if(score1.find(el=>el.UID===kunde.UID))
                {
                  if(score2.find(el=>el.UID===kunde.UID))
                  {
                    if(!score3.find(el=>el.UID===kunde.UID))
                      score3.push(kunde)
                  }
                  if(!score2.find(el=>el.UID===kunde.UID))
                    score2.push(kunde)
  
                }
                else
                {
                  score1.push(kunde)
                }
              })
          })
         
          if(score3.length===1 || score2.length===1)
          {
            
            stopTextScan()
            setUserDetected(score3.length ? score3 : score2)
            window.navigator.vibrate([200,200,200]);
          }
          else if(score1.length )
          {
            ++scanTriesMulti.current
            if(scanTriesMulti.current  >3)
            {
              window.navigator.vibrate([200,100,200,100,200]);
              setUserDetected(score3.length ? score3 :(score2.length ? score2 : score1))
              setKorrektur(true)
              stopTextScan()
           }
          }
          else  if(score1.length ===0 )
          {

              ++scanTriesZero.current
              if(scanTriesZero.current  >10)
              {
                setKorrektur(true)
                window.navigator.vibrate([700]);
                stopTextScan()
                history.push(`/register/paket/${dienst}/correct`)
              }
          }

        }
       

      }
      catch (e) {
        ++detectorError.current
        if(detectorError.current<3)
        {
          console.log('text Scan error: ' + e)
          if(detectorText.current)
          {
            detectorText.current=null
            await delay(500)
            detectorText.current = new window.TextDetector();

          }
         
        }
        else
        {
          alert('Texterkennung fehlgeschlagen, Browser bitte neu starten')
          setScanningStep(null)
        }

      }
      setCount(c=>++c)
    }

   


    if(ocrActive.current )
      scanText()


  },[count,ocrActive.current,scanningStep])

  return [userDetected,setUserDetected]
}  
export default useOcr 
